export type TermType = 'weekly' | 'monthly' | 'yearly' | 'lifetime' | 'consumable';

export interface SKU {
  _id: string;
  sku: string;
  price: number;
  currency: string;
  term: TermType;
  termSku?: string;
  isActive: boolean;
  description?: string;
  createdAt: string;
}

export interface SKUFormData {
  sku: string;
  price: number;
  currency: string;
  term: TermType;
  termSku?: string;
  isActive: boolean;
  description?: string;
}

export interface AdjustConfig {
  _id: string;
  appName: string;
  appToken: string;
  events: Record<string, string>;
  tvToken?: string;
  tvEvents?: Record<string, string>;
  skus?: SKU[];
}

interface SKUListData {
  appName: string;
  totalSkus: number;
  activeSkus: number;
  inactiveSkus: number;
  skus: SKU[];
}

export interface SKUListResponse {
  success: boolean;
  data?: SKUListData;
  result?: SKUListData;
}

export interface SKUActionResponse {
  success: boolean;
  data?: {
    message: string;
    sku?: SKU;
    totalSkus?: number;
    remainingSkus?: number;
  };
  message?: string;
}

export const TERM_OPTIONS: { value: TermType; label: string }[] = [
  { value: 'weekly', label: 'Weekly' },
  { value: 'monthly', label: 'Monthly' },
  { value: 'yearly', label: 'Yearly' },
  { value: 'lifetime', label: 'Lifetime' },
  { value: 'consumable', label: 'Consumable' },
];

export const CURRENCY_OPTIONS = [
  { code: 'USD', symbol: '$', label: 'US Dollar' },
  { code: 'EUR', symbol: '€', label: 'Euro' },
  { code: 'GBP', symbol: '£', label: 'British Pound' },
  { code: 'JPY', symbol: '¥', label: 'Japanese Yen' },
  { code: 'CAD', symbol: 'CA$', label: 'Canadian Dollar' },
  { code: 'AUD', symbol: 'A$', label: 'Australian Dollar' },
];
